import { Tabs } from "@caelor/ui";
import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TabsSettings } from "./defaults";
import LayoutSettings from "./LayoutSettings";
import ContentSettings from "./ContentSettings";

function UpcomingBirthdaySettings() {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("layout");

  return (
    <>
      <Tabs
        tabs={TabsSettings}
        i18n={t}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      {selectedTab === "layout" && <LayoutSettings />}
      {selectedTab === "content" && <ContentSettings />}
    </>
  );
}

export default UpcomingBirthdaySettings;
